import { combineReducers } from 'redux';
import { createReducer } from 'utils';
import types from './types';

const editedSlug = createReducer('', {
  [types.SET_EDITED_SLUG]: (state, action) => action.payload,
});

const isSaving = createReducer(false, {
  [types.SET_IS_SAVING]: (state, action) => action.payload,
});

const EateryEditor = combineReducers({
  editedSlug,
  isSaving,
});

export default {
  EateryEditor,
};
